import type { ContextMenuAnchor } from "./anchor";
import { ContextMenuLayer } from "./ContextMenuLayer";
import type { ContextMenuItem } from "./items";

export type { ContextMenuAnchor, ContextMenuState } from "./anchor";
export type { Point, Rect, Size } from "./geometry";
export type { ContextMenuAction, ContextMenuCheckbox, ContextMenuHeading, ContextMenuItem, ContextMenuRadio, ContextMenuSubmenu } from "./items";
export { isInteractive, isItemDisabled } from "./items";
export { nextIndex, typeaheadIndex } from "./navigation";
export { MENU_MARGIN, placeMenu, placeSubmenu } from "./placement";
export type { ContextMenuTriggerProps } from "./triggerProps";
export { isContextMenuKey } from "./triggerTarget";
export type { UseContextMenuOptions } from "./useContextMenu";
export { useContextMenu } from "./useContextMenu";

export interface ContextMenuProps {
  /** Where it is open; null renders nothing. Usually `useContextMenu().state`. */
  state: ContextMenuAnchor | null;
  items: ContextMenuItem[];
  onClose: () => void;
  ariaLabel: string;
}

/**
 * Context menu rendered in a portal to <body> (fixed positioning is never offset by a transformed
 * ancestor). Roles menu / menuitem / menuitemcheckbox / menuitemradio; arrows, Home/End, Enter and
 * Space, → and ← for submenus, Escape, typeahead. Closes on outside click, scroll, resize, blur and
 * history navigation, and returns focus to where it was.
 */
export function ContextMenu({ state, items, onClose, ariaLabel }: ContextMenuProps): React.JSX.Element | null {
  if (!state) return null;
  return <ContextMenuLayer state={state} items={items} onClose={onClose} ariaLabel={ariaLabel} />;
}
